import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { ReceiveHistoryListing, ReceiveHistorySummary } from '~/models/modules/ReceiveHistorySummary';

@Injectable({ providedIn: 'root' })
export class ReceiveTransactionsService extends ApiServiceBase {
  FromInventory: any = [];
  SelectedSalesOrderId: number;
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  createReceive(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  getReceiveHistories(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<ReceiveHistorySummary[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  GetReceiveTransactionByStockItem(stockItemId: number, model: any) {
    return this.http.post<ReceiveHistorySummary[]>(this._url(`/StockItems/${stockItemId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  GetReceiveTransactionByCategory(categoryId: number, model: any) {
    return this.http.post<ReceiveHistorySummary[]>(this._url(`/Categories/${categoryId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  GetReceiveTransactionByUOM(unitOfMeasureId: number, model: any) {
    return this.http.post<ReceiveHistorySummary[]>(this._url(`/UnitOfMeasures/${unitOfMeasureId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  GetReceiveTransactionByVendor(vendorId: number, model: any) {
    return this.http.post<ReceiveHistorySummary[]>(this._url(`/Vendors/${vendorId}/grid-data`), model, { observe: 'response' }).pipe(map(augmentPaging));
  }

  getReceiveListing() {
    return this.client.get<ReceiveHistoryListing[]>(this._url());
  }

  GetNumberOfStockItemsReceivedLastXMonths(top: number) {
    return this.client.get(this._url(`/GetNumberOfStockItemsReceivedLastXMonths/${top}`));
  }

  GetReceivedQuantityPerMonths(top: number) {
    return this.client.get(this._url(`/GetReceivedQuantityPerMonths/${top}`));
  }

  NumberOfReceivedTransactionLastXMonths(top: number) {
    return this.client.get(this._url(`/NumberOfReceivedTransactionLastXMonths/${top}`));
  }

  QuantityOfReceivedStockItemsPerSupplier(top: number) {
    return this.client.get(this._url(`/QuantityOfReceivedStockItemsPerSupplier/${top}`));
  }

  NumberOfStockItemsReceivedPerUser(top: number) {
    return this.client.get(this._url(`/NumberOfStockItemsReceivedPerUser/${top}`));
  }

  NumberOfPosReceivedPerUser(top: number) {
    return this.client.get(this._url(`/NumberOfPosReceivedPerUser/${top}`));
  }

  NumberOfItemsPerPOs(top: number) {
    return this.client.get(this._url(`/NumberOfItemsPerPOs/${top}`));
  }

  TotalCostOfPO(top: number) {
    return this.client.get(this._url(`/TotalCostOfPO/${top}`));
  }

  MostExpensivePO(top: number) {
    return this.client.get(this._url(`/MostExpensivePO/${top}`));
  }

  POLeadTime(top: number) {
    return this.client.get(this._url(`/POLeadTime/${top}`));
  }

  private _url(v?: string | undefined) {
    v = v || '';

    return this.url(`/ReceiveTransactions${v}`);
  }
}
